module.exports = __webpack_public_path__ + "static/media/sociology.a2158987.jpg";